module.exports = __webpack_public_path__ + "static/media/07.07c03e6b.mp3";